// extracted by mini-css-extract-plugin
export default {"container":"resetPassword_container__3Yp3M","form":"resetPassword_form__OTFTU","input":"resetPassword_input__PWfOO","button":"resetPassword_button__34jsY"};